import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {EditHardwareGroupWithContent} from "./HwEditingContextProvider";
import {useRef, useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {useHwAPI} from "./HardwareGeneric";
import {useSnackbar} from "../../../../misc/Snackbar";

export function EditNotesDialog(props: {
    onClose(): void;
    onUpdated(): void;
    value: EditHardwareGroupWithContent;
}) {
    const [note, setNote] = useState(props.value.notes);
    const hapi = useHwAPI();
    const snack = useSnackbar();

    const onUpdatedRef = useRef(props.onUpdated);
    onUpdatedRef.current = props.onUpdated;

    const update = useAsyncAction(async (input) => {
        const rs = await hapi.upsert(input);
        if(!rs.updated) throw new Error("Failed to update, please refresh the page and try again")

        snack.success("Updated note");
        onUpdatedRef.current();
    }, []);

    const submit = () => {
        update.callback({
            value: Object.assign({}, props.value, {notes: note})
        });
    };

    return (
        <Dialog2 open maxWidth="md" fullWidth onClose={props.onClose} onEnterPress={submit}>
           <DialogTitle>Edit Notes</DialogTitle>
           <DialogContent>

               <div style={{height: 8}} />

               <TextField
                   label="Notes"
                   value={note}
                   onChange={e => setNote(e.target.value)}
                   multiline
                   rows={4}
                   fullWidth
               />

           </DialogContent>
           <SmoothActionBar
               loading={update.loading}
               error={update.error}
               actionName="Update"
               onCancel={props.onClose}
               onSubmit={submit}
           />
        </Dialog2>
    )
}